import './CSS_styles/heading.css';
import Topbar from "./topbar";

function App() {
  return <Topbar />;
}

export default App;